import Vue from 'vue'
import Vuex from 'vuex'
import Storage from '../utils/storage'

Vue.use(Vuex)



export default new Vuex.Store({
  state: {
    token: null,
    userInfo: null,
    currentTeam: null,
    loading: false,
    ScoreData: [],
    cToken: '',
    currentTeamList: [],
    eventData: [],
    medal: null,
    eventVisible: false,
    eventFilterInfo: null,
    tableCompetitions: null,
    tablePlayers: null,
    matchListAll: null,
    editMode: false,
    playersInfo: null,
    specialMatch: [
      {"match_id":"51","match_eng_name":"Asian Championships 2023"},
      {"match_id":"57","match_eng_name":"the Asian Games 2023"},
      {"match_id":"218","match_eng_name":"Asian Youth Championships 2024"}
    ],
    playerRankings: [],
  },
  mutations: {
    setEditMode(state){
      state.editMode=!state.editMode
    },
    setLoading(state,info){
      state.loading = info
    },
    setToken(state,info) {
      state.token = info
      Storage.set('token', info)
    },
    clearToken(state) {
      state.token = null
      Storage.clear('token')
    },
    setUserInfo(state, info) {
      state.userInfo = info
      Storage.set('userInfo', info)
    },
    clearUserInfo(state) {
      state.userInfo = null
      Storage.clear('userInfo')
    },
    setCurrentTeamList(state, list) {
      state.currentTeamList = list
      Storage.set('currentTeamList', list)
    },
    setCurrentTeam(state, info) {
      state.currentTeam = info
      Storage.set('currentTeam', info)
    },
    clearCurrentTeamList(state) {
      state.currentTeamList = null
      Storage.clear('currentTeamList')
    },
    clearCurrentTeam(state) {
      state.currentTeam = null
      Storage.clear('currentTeam')
    },
    setGetScoreRes(state, info) {
      state.ScoreData = info
    },
    setCToken(state, info) {
      state.cToken = info
    },
    setMatchListAll(state, info) {
      state.matchListAll = info
    },
    setEventData(state, info){
      state.eventData = info
    },
    setMedal(state, info){
      state.medal = info
    },
    setEventFilterData(state, info){
      state.eventVisible = info.eventVisible
      if(info.eventVisible) {
        state.eventFilterInfo = info
      }
    },
    setTableCompetitions(state, info) {
      state.tableCompetitions = info
    },
    setTablePlayers(state, info) {
      const result = {}
      info.forEach(player => {
        result[player.player_id] = player
      })
      state.tablePlayers = result
    },
    setPlayersInfo(state, info) {
      const result = {}
      info.forEach(player => {
        result[player.player_id] = player
      })
      state.playersInfo = result
    },
    setPlayerRankings(state, ranking) {
      state.playerRankings = ranking
    },
  },
  actions: {

  },
  modules: {
  }
})
